// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tides-page {
  padding: 2rem 0;
  min-height: 80vh;
}

.tides-page .container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
}

.tides-page .page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  color: var(--text-primary);
}

.tides-intro {
  margin-bottom: 2rem;
}

.intro-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.intro-card p {
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0 0 1rem 0;
}

.intro-card a {
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 500;
}

.intro-card a:hover {
  text-decoration: underline;
}

/* Scrollable Content */
.tides-content-scroll {
  position: relative;
  max-width: 100%;
}

.tides-content-section {
  margin-bottom: 3rem;
}

.content-card {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 2rem;
}

.content-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 1rem 0;
}

.content-card h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 1.5rem 0 0.75rem 0;
}

.content-card p {
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0 0 1rem 0;
}

.content-card a {
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 500;
}

.content-card a:hover {
  text-decoration: underline;
}

.info-box {
  background: var(--bg-secondary);
  border-left: 4px solid var(--accent-primary);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1.5rem 0;
}

.info-box.warning {
  border-left-color: #f59e0b;
  background: var(--bg-tertiary);
}

.info-box h4 {
  margin-top: 0;
  color: var(--text-primary);
}

.info-box p {
  margin-bottom: 0.75rem;
}

.info-box p:last-child {
  margin-bottom: 0;
}

.content-card ol,
.content-card ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.content-card li {
  color: var(--text-primary);
  line-height: 1.6;
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .tides-page .container {
    padding: 0 1rem;
  }

  .tides-content-section {
    margin-bottom: 2rem;
  }

  .content-card {
    padding: 1.5rem;
  }

  .content-card h3 {
    font-size: 1.3rem;
  }

  .content-card h4 {
    font-size: 1.1rem;
  }

  .intro-card {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .tides-content-section {
    margin-bottom: 1.5rem;
  }

  .content-card {
    padding: 1rem;
  }

  .content-card h3 {
    font-size: 1.2rem;
  }

  .info-box {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TidesPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".tides-page {\r\n  padding: 2rem 0;\r\n  min-height: 80vh;\r\n}\r\n\r\n.tides-page .container {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n}\r\n\r\n.tides-page .page-title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.tides-intro {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.intro-card {\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.intro-card p {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.intro-card a {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.intro-card a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Scrollable Content */\r\n.tides-content-scroll {\r\n  position: relative;\r\n  max-width: 100%;\r\n}\r\n\r\n.tides-content-section {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.content-card {\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n}\r\n\r\n.content-card h3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.content-card h4 {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 1.5rem 0 0.75rem 0;\r\n}\r\n\r\n.content-card p {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.content-card a {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.content-card a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.info-box {\r\n  background: var(--bg-secondary);\r\n  border-left: 4px solid var(--accent-primary);\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  margin: 1.5rem 0;\r\n}\r\n\r\n.info-box.warning {\r\n  border-left-color: #f59e0b;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.info-box h4 {\r\n  margin-top: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.info-box p {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.info-box p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.content-card ol,\r\n.content-card ul {\r\n  margin: 1rem 0;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.content-card li {\r\n  color: var(--text-primary);\r\n  line-height: 1.6;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .tides-page .container {\r\n    padding: 0 1rem;\r\n  }\r\n\r\n  .tides-content-section {\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  .content-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .content-card h3 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .content-card h4 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .intro-card {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .tides-content-section {\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .content-card {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .content-card h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .info-box {\r\n    padding: 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
